<template>
  <div class="wl">
    <div class="datalist">
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="lable">{{ item.lable }}</div>
        <div class="num">
          {{ item.num }}
          <div class="unit" v-if="index === 0">单</div>
        </div>
      </div>
    </div>
    <div class="main1">
      <div class="left">
        <div class="content w-70">
          <div class="tips">
            月度物流数据统计
          </div>
          <div id="bg-charts1"></div>
        </div>
      </div>
      <div class="right">
        <div class="content w-70">
          <div class="tips">
            运单目的国统计
          </div>
          <div class="left">
            <div id="bg-charts2"></div>
          </div>
          <div class="country">
            <div v-for="(item, index) in tabHead" :key="index">
              {{ item.title }}
            </div>
          </div>
          <div class="topCustomsWeightSummary">
            <div v-for="(item, index) of countryList" :key="index" class="item">
              <div class="icon" :style="{ background: colors[index] }"></div>
              <div class="contenttext">
                <div class="name">{{ item.countryName | isEmptyVal }}</div>
                <div class="name">{{ getRate(item) }}</div>
                <div class="num">
                  <span>{{ item.shipNum || 0 | formatNumber }}</span>
                  <span class="unit">单</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main1">
      <div class="left">
        <div class="content w-70">
          <div class="tips">
            物流服务商下单统计
          </div>
          <div id="jygl-charts3">
            <div class="item" v-for="(item, index) in companyList" :key="index">
              <div class="top">
                <div :style="{ background: item.color }" class="index">
                  {{ index + 1 }}
                </div>
                <div class="name">{{ item.orgName }}</div>
              </div>
              <div class="bottom">
                <div
                  :style="{ background: '#51b2bb', width: item.width }"
                  class="line"
                ></div>
                <div class="quantity" :style="{ color: item.color }">
                  {{ item.shipNum }}单
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="content w-70">
          <div class="tips">
            物流渠道下单占比
          </div>
          <div id="bg-charts3"></div>
        </div>
        <div class="country wuList">
          <div v-for="(item, index) in wlHead" :key="index">
            {{ item.title }}
          </div>
        </div>
        <div>
          <div class="channelList">
            <div
              class="items"
              v-for="(item, index) in channelList"
              :key="index"
            >
              <div class="channelName">
                <img :src="img" class="imgs" alt="" />{{ item.channelName }}
              </div>
              <div class="quantity">{{ item.shipNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tableList">
      <div class="line1 line2">
        <div class="content w-100">
          <div class="tips">
            物流运单明细
          </div>
          <div class="table">
            <div class="ux-filter-records filter-records">
              <div class="content-list" style="height:auto">
                <el-table
                  empty-text="暂无数据"
                  class="table ux-dark-el-table"
                  :data="tableData"
                  max-height="570"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-table-column
                    v-for="(props, i) in tableHeader"
                    :label="props.label"
                    align="left"
                    :key="i"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <div class="text">
                        {{ scope.row[props.prop] || "--" }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <div class="blue" @click="toDetail(scope.row)">详情</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="pages">
                <span>共 {{ page.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="page.current"
                  :page-size="page.size"
                  :total="page.total"
                  @current-change="currentChange"
                />
                <pagination
                  @currentChange="currentChange"
                  @sizeChange="sizeChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiPath from '@config/api.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import img from '../../../../../assets/images/common/wuliu.svg'
const { mapState, mapMutations } = require('vuex')
export default {
  props: ['info'],
  components: { pagination },
  data () {
    return {
      img,
      companyList: [
        // {
        //   companyName: '深圳市风火轮技术3',
        //   quantity: 55,
        //   width: '50px'
        // }
      ],
      colors3: [
        'rgb(236,154,86)',
        'rgb(230,202,95)',
        'rgb(107,215,156)',
        'rgb(138,63,243)',
        'rgb(81,163,192)'
      ],
      dataList: [
        {
          lable: '物流订单数量（汇总）',
          num: 0
        },
        {
          lable: '订单总金额（CNY）',
          num: 0
        },
        {
          lable: '订单总重量（kg）',
          num: 0
        },
        {
          lable: '包裹总件数',
          num: 0
        },
        {
          lable: '总运费（CNY）',
          num: 0
        }
      ],
      declarationMonthStatistics: [],
      countryList: [],
      tabHead: [
        {
          title: '目的国'
        },
        {
          title: '占比'
        },
        {
          title: '数量'
        }
      ],
      wlHead: [
        {
          title: '物流渠道'
        },
        {
          title: '下单次数'
        }
      ],
      channelList: [],
      topCustomsWeightSummary: [],
      colors: ['#B7BA52', '#4EC37C', '#50CFFF', '#0171FC', '#6543D6'],
      tableData: [],
      tableHeader: [
        {
          prop: 'customerNumber',
          label: '订单编号'
        },
        {
          prop: 'transaction',
          label: '订单金额'
        },
        {
          prop: 'trackNumber',
          label: '物流运单编号'
        },
        {
          prop: 'orgName',
          label: '物流运单企业'
        },
        {
          prop: 'countryName',
          label: '运抵国（地区）'
        },
        {
          prop: 'number',
          label: '件数'
        },
        {
          prop: 'totalWeight',
          label: '订单总重量'
        },
        {
          prop: 'shippingPrice',
          label: '运费USD'
        },
        {
          prop: '',
          label: '保费USD'
        },
        {
          prop: 'recipientName',
          label: '收件人'
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapState({
      searchDate: state => {
        return state.home.searchDate
      }
    })
  },
  watch: {
    searchDate: function (n) {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapMutations({}),
    init () {
      this.getOrgLogistics()
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getEnterpriseLogistics}${this.info.customerNo}`
      }).then(res => {
        console.log('物流服务商', res)
        if (res.data) {
          const {
            shipNum,
            totalValue,
            totalWeight,
            shippingPrice,
            number
          } = res.data
          this.dataList[0].num = shipNum
          this.dataList[1].num = totalValue
          this.dataList[2].num = totalWeight
          this.dataList[3].num = number
          this.dataList[4].num = shippingPrice
          // this.declarationMonthStatistics = monthList || []
          // this.countryList = countryList || []
          // this.topCustomsWeightSummary = countryList
          // this.channelList = channelList || []
          // if (this.channelList.length > 0) {
          //   this.initCharts3()
          // }
          let data = []
          data.push(res.data)
          this.initCharts1()
          this.initCharts2()
          this.initCharts3()
        }
      })
      this.getlist()
    },
    getOrgLogistics () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getEnterpriseOrgLogistics}${this.info.customerNo}`
      }).then(res => {
        this.getCompanyList(res.data || [])
      })
    },
    // 处理物流服务商统计
    getCompanyList (data) {
      let nums = []
      data.forEach(item => {
        nums.push(item.shipNum)
      })
      let max = Math.max.apply(null, nums)
      data.forEach((item, index) => {
        item.width = Math.round((item.shipNum / max) * 100) + '%'
        item.color = this.colors3[index]
      })
      this.companyList = data
      console.log('companyList', this.companyList)
    },
    getlist () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.wl.getEnterpriseLogisticsDetail}`,
        data: {
          // searchDate: this.searchDate,
          // companyNo: this.info.companyNo,
          pageNum: this.page.current,
          pageSize: this.page.size,
          customerNo: this.info.customerNo
        }
      }).then(res => {
        if (res && res.data) {
          this.tableData = res.data.records || []
          this.page.total = res.data.total || 0
        }
      })
    },
    initCharts1 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getLogisticsEnterpriseMonthly}${this.info.customerNo}`
      }).then(res => {
        if (res.data) {
          this.declarationMonthStatistics = res.data
          let declarationMonthStatistics = []
          for (let i = 0; i < 12; i++) {
            let monthNum = i + 1 <= 9 ? '0' + (i + 1) : i + 1
            for (let e of this.declarationMonthStatistics) {
              if (!e.monthDay.split('-')[1].includes(monthNum)) continue
              declarationMonthStatistics[i] = e.shipNum
            }
            if (!declarationMonthStatistics[i]) {
              declarationMonthStatistics[i] = 0
            }
          }
          var chartDom = document.getElementById('bg-charts1')
          var myChart = this.$echarts.init(chartDom)
          let option
          option = {
            grid: {
              left: 0,
              right: 0,
              bottom: 0,
              top: 67,
              containLabel: true
            },
            legend: {
              data: ['运单数量'],
              right: '10%',
              textStyle: {
                color: '#fff'
              }
            },
            xAxis: {
              type: 'category',
              data: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月'
              ],
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: 'rgba(227, 242, 252, 0.39)',
                  width: 45,
                  type: 'solid'
                },
                z: 0 // 注意要设置层级，不然会在覆盖在柱子前面，设置为0就在柱子后面显示了。
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            series: [
              {
                name: '运单数量',
                data: declarationMonthStatistics,
                type: 'line',
                smooth: true,
                areaStyle: {
                  textStyle: {
                    color: '#fff'
                  }
                }
              }
            ]
          }
          option && myChart.setOption(option)
        }
      })
    },
    initCharts2 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getLogisticsDestination}${this.info.customerNo}`
      }).then(res => {
        if (res.data) {
          this.countryList = res.data
          var chartDom = document.getElementById('bg-charts2')
          var myChart = this.$echarts.init(chartDom)
          let arr = []
          this.countryList.forEach(item => {
            arr.push({
              value: item.shipNum,
              name: item.countryName
            })
          })
          let option
          option = {
            tooltip: {
              trigger: 'item'
            },
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['37%', '50%'],
                center: ['20%', '50%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: 26,
                    fontWeight: 'bold',
                    color: '#fff'
                  }
                },
                labelLine: {
                  show: false
                },
                data: arr
              }
            ]
          }
          option && myChart.setOption(option)
        }
      })
    },
    initCharts3 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getLogisticsChannel}${this.info.customerNo}`
      }).then(res => {
        if (res.data) {
          this.channelList = res.data
          var chartDom = document.getElementById('bg-charts3')
          var myChart = this.$echarts.init(chartDom)
          let channelList = this.channelList
          let data1 = []
          channelList.forEach(item => {
            data1.push(item.shipNum)
          })
          let max = Math.max.apply(null, data1)
          let indicatorData = []
          this.channelList.forEach(item => {
            indicatorData.push({
              name: item.channelName,
              max: max
            })
          })
          let option
          option = {
            radar: {
              center: ['20%', '50%'],
              radius: '50%',
              indicator: indicatorData,
              // [
              //   { name: 'Sales', max: 6500 },
              //   { name: 'Administration', max: 16000 },
              //   { name: 'Information Technology', max: 30000 },
              //   { name: 'Customer Support', max: 38000 },
              //   { name: 'Development', max: 52000 },
              //   { name: 'Marketing', max: 25000 }
              // ],
              axisName: {
                show: false
              },
              axisLine: {
                show: false
              },
              splitArea: {
                show: false
              }
            },
            series: [
              {
                type: 'radar',
                data: [
                  {
                    value: data1
                  }
                ]
              }
            ]
          }
          option && myChart.setOption(option)
        }
      })
    },
    currentChange (e) {
      this.page.current = e
      this.getlist()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getlist()
    },
    toDetail (row) {
      let detailObj = row || {}
      detailObj.activeName = this.activeName
      detailObj.info = this.info
      this.$store.dispatch('getisShowDetail', 4)
      this.$store.dispatch('getShowDetail', detailObj)
    },
    getRate (item) {
      let num = Math.round(item.proportion * 100)
      return num + '%'
    }
  }
}
</script>
<style lang="scss" scoped>
.wl {
  .datalist {
    display: flex;
    margin-top: 30px;
    margin-bottom: 24px;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 40px;
    .item {
      width: 280px;
      height: 128px;
      border-radius: 10px;
      background: linear-gradient(
        180deg,
        rgba(9, 43, 78, 1) 0%,
        rgba(9, 43, 43, 0) 100%
      );
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      font-family: Roboto;
      border: 1px solid rgba(40, 96, 134, 1);
      .lable {
        margin: 20px;
        font-size: 20px;
      }
      .num {
        display: flex;
        margin-left: 20px;
        color: rgba(252, 202, 0, 1);
        font-size: 28px;
      }
      .unit {
        font-size: 20px;
        margin-left: 16px;
      }
    }
  }
  .main1 {
    display: flex;
    margin: 0px 23px;
    justify-content: space-between;
    height: 440px;
    margin-bottom: 72px;
    .content {
      border: 1px solid rgb(71, 166, 234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin: 0 16px 16px 16px;
      .tips {
        position: relative;
        top: 20px;
        left: 20px;
        width: 198px;
        height: 43px;
        line-height: 43px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(3, 196, 219, 0.16) 100%
        );
        border-left: 2px solid #fff;
        font-size: 20px;
        padding-left: 13px;
      }
      .title {
        text-align: center;
        font-size: 18px;
      }
    }
    .w-70 {
      width: 797px;
      height: 100%;
      // margin-right:20px;
      // margin-left:32px;
    }
    .right {
      position: relative;
      .country {
        display: flex;
        position: absolute;
        right: 200px;
        top: 100px;
        color: rgba(1, 153, 227, 1);
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        font-weight: 700;
        width: 250px;
      }
      .wuList {
        right: 228px;
        width: 223px;
      }
      .topCustomsWeightSummary {
        position: absolute;
        right: 150px;
        top: 140px;
        .item {
          cursor: pointer;
          display: flex;
          width: 300px;
          padding: 0px 20px 0px 10px;
          justify-content: space-between;
          align-items: center;
          background: rgba(63, 154, 255, 0.2);
          margin-bottom: 12px;

          .icon {
            width: 8px;
            height: 8px;
            background: #b7ba52;
            margin-left: 7px;
            border-radius: 50%;
          }

          .contenttext {
            margin-left: 17px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1;
            font-size: 14px;

            .name {
              width: 33.33%;
              max-width: 90px;
              overflow: hidden;
              line-height: 24px;
              height: 24px;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 10px;
            }

            .num {
              // width: 36px;
              text-align: right;
              white-space: nowrap;

              .unit {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
  .tableList {
    margin: 0px 20px;
    position: relative;
    .content {
      border: 1px solid rgb(71, 166, 234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin: 0 16px 16px 16px;
      .top {
        display: flex;
        font-size: 18px;
        .icon {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71, 166, 234);
          margin-right: 16px;
        }
      }
      .tips {
        position: absolute;
        top: 30px;
        left: 60px;
        width: 198px;
        height: 43px;
        line-height: 43px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(3, 196, 219, 0.16) 100%
        );
        border-left: 2px solid #fff;
        font-size: 20px;
        padding-left: 13px;
      }
      .table {
        margin-top: 40px;
        height: 660px;
      }
      .title {
        text-align: center;
        font-size: 18px;
      }
    }
  }
  #jygl-charts3 {
    margin: 60px 0px 10px 10px;
    height: 700px;
    .item {
      margin-bottom: 12px;
      color: #fff;
      font-size: 12px;
      .top {
        display: flex;
        align-items: center;
        font-size: 16px;
      }
      .index {
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        margin-right: 16px;
      }
      .name {
        margin-right: 16px;
        min-width: 100px;
      }
      .unit {
        color: rgb(71, 166, 234);
      }
      .bottom {
        font-size: 18px;
        display: flex;
        align-items: center;
        margin: 6px 0 16px 46px;
      }
      .line {
        height: 16px;
        border-radius: 10px;
        min-width: 20px;
        margin-right: 10px;
      }
      .quantity {
        text-align: left;
        width: 100px;
      }
    }
  }
}
#bg-charts1 {
  position: absolute;
  width: 100%;
  height: 400px;
  position: relative;
}
#bg-charts2 {
  position: absolute;
  width: 100%;
  height: 400px;
  position: relative;
}
#bg-charts3 {
  position: absolute;
  width: 100%;
  height: 400px;
  position: relative;
}
.channelList {
  position: absolute;
  right: 267px;
  top: 140px;
  width: 200px;
  .items {
    width: 200px;
    display: flex;
    justify-content: space-between;
    .channelName {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        margin-right: 7px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/wl.vue